export enum ResourceFileTokens {
    ASSETS_URL = 'ASSETS_URL',
}